export const tr = {
    'empty-words': 'Netleştirici sözcük yok',
    'empty-words-content':
        'Netleştirmeler bulunamadı. Sözcük grubunu netleştirmek için negatif anahtar sözcüklerini manuel olarak ekleyin.',
    'error-words': 'Netleştirmeler yüklenemedi',
    'refine-note': 'Anahtar sözcük grubunu netleştirmek için negatif anahtar sözcüklerini işaretleyin.',
    'show-more': 'Daha fazla göster',
    'shows-text': 'Aylık gösterim tahmini: {showsCount}',
    'word-shows': {
        one: '{count} gösterim',
        some: '{count} gösterim',
        many: '{count} gösterim',
        none: '{count} gösterim'
    }
};
